import { render, staticRenderFns } from "./Dashboard-topnav.vue?vue&type=template&id=0747b21e&scoped=true&"
import script from "./Dashboard-topnav.vue?vue&type=script&lang=js&"
export * from "./Dashboard-topnav.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-topnav.vue?vue&type=style&index=0&id=0747b21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747b21e",
  null
  
)

export default component.exports